<script>
    // @ts-nocheck
    import {
        Button,
        Typography,
        InputFile,
        Row,
        Column,
        InputText,
    } from '$lib/components/UI'
    import {
        TrashOutline,
        AddOutline,
        PencilSharp,
        TrashSharp,
        SaveSharp,
    } from '$lib/components/Icons'
    import Edit from '$lib/components/Icons/custom/Edit.svelte'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import Select from '$lib/components/UI/Select2.svelte'
    import SelectX from '$lib/components/UI/SelectX.svelte'
    import dictionaries from '../../stores/dictionaries'
    import createDataStore from '../../stores/datastore'
    import { createEventDispatcher, onMount } from 'svelte'
    import { currencyFormatter } from '$lib/utils'
    export let value = []
    export let disabled = false
    export let valid = true
    export let validation = (x) => true
    const dispatch = createEventDispatcher()
    let percepcionesStore = createDataStore(
        value instanceof Array ? value : [],
        (x) => x.percepcion
    )
    let loadPerceptions = false
    let itemForm = {}
    let schema = {
        provincia: {
            render: (v) =>
                $dictionaries.vprovincias?.find((t) => t.value === v)
                    ?.label || '',
        },
        desc: {
            label: 'Descripcion',
            render: (_, item) =>
                $dictionaries.lic_percepciones?.find(
                    (t) => t.value === item?.percepcion
                )?.label || '',
        },
        // percepcion: {
        //     label: 'Percepción',
        // },
        monto: {
            label: 'Monto',
            render: (n) =>
                n ? currencyFormatter({ n, type: 'ARS', lang: 'es-AR' }) : '-',
        },
    }
    let editMode = false
    const rel = {
        '901': ['4I4'],
        '902': ['4M7', '4N0', '4S0', '615', '769'],
        '903': ['4L5', '4L5'],
        '904': ['4K1', '4L6'],
        '905': ['4L7'],
        '906': ['4M0'],
        '907': ['4M8'],
        '908': ['4M3'],
        '909': ['4L0', '4L9'],
        '910': ['4I8', '4M1'],
        '911': ['4M4'],
        '912': ['4M5'],
        '913': ['4I7'],
        '914': ['4I9', '4J7'],
        '915': ['4L8'],
        // '916': ['']
        '917': ['4K6'],
        '918': ['4J5'],
        '919': ['4J6'],
        '920': ['4M2'],
        '921': ['4J2', '4K8'],
        '922': ['4M6'],
        '923': ['4M9'],
        '924': ['4K3'],
    }

    function updateItem(item) {
        let { id, ...data } = item
        percepcionesStore.update(id, data)
        editMode = false
        clearForm()
    }

    function addItem(item) {
        percepcionesStore.add(item)
        editMode = false
        clearForm()
    }

    function submitItem() {
        if (editMode) {
            updateItem(itemForm)
        } else {
            addItem(itemForm)
        }
    }

    function clearForm() {
        itemForm = {}
        editMode = false
    }

    /* Fix */
    setTimeout(() => {
        percepcionesStore.forceRefresh()
    }, 500)

    $: provincias_rec =
        $dictionaries.vprovincias?.filter((t) => t.value in rel) || []
    $: retenciones_rec =
        $dictionaries.lic_percepciones?.filter((term) =>
            itemForm.provincia &&
            (editMode ? true : !percepcionesStore.exists(term.value)) &&
            itemForm.provincia in rel
                ? rel[itemForm.provincia].includes(term.value)
                : false
        ) || []
    $: validItem = Object.values(itemForm).every((x) => x)
    $: value = $percepcionesStore
    $: valid = validation(value)
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<Datatable bind:data={percepcionesStore} {schema}>
    <svelte:fragment slot="endOfRow" let:item>
        <span style="display: flex; gap: 8px; margin: auto">
            <i
                style="cursor: pointer"
                on:click={() => {
                    itemForm = structuredClone(item)
                    editMode = true
                }}
            >
                <PencilSharp size={18} title="Editar" />
            </i>
            <i
                style="cursor: pointer"
                on:click={() => percepcionesStore.delete(item.id)}
            >
                <TrashSharp size={18} title="Borrar" />
            </i>
        </span>
    </svelte:fragment>
    <svelte:fragment slot="noContent">
        <p style="color: var(--color-grey-400)">
            No se ha cargado ninguna percepción.
        </p>
    </svelte:fragment>
</Datatable>
{#key value || editMode}
    <Column>
        <Row>
            <SelectX
                label="Provincia"
                bind:value={itemForm.provincia}
                bind:options={provincias_rec}
            />
            {#key itemForm.provincia}
                <SelectX
                    label="Percepción"
                    disabled={retenciones_rec?.length === 0 || disabled}
                    bind:value={itemForm.percepcion}
                    bind:options={retenciones_rec}
                />
            {/key}
            <InputText
                prefix="$"
                label="Monto"
                validation={(v) =>
                    v && v.length > 0 && /^[0-9]+(\.[0-9]+)?$/.test(v)}
                on:keypress={({
                    detail: {
                        eventTarget: { key },
                    },
                }) => {
                    if (key === 'Enter' && validItem) submitItem()
                }}
                bind:value={itemForm.monto}
            />
        </Row>
        <Row>
            {#if editMode}
                <Button
                    type="other"
                    size="small"
                    label="Cancelar"
                    on:click={() => {
                        clearForm()
                    }}
                />
            {/if}
            <Button
                size="small"
                disabled={!validItem}
                label={!editMode ? 'Agregar percepción' : 'Guardar'}
                on:click={submitItem}
            >
                {#if editMode}
                    <SaveSharp color="white" size={20} />
                {:else}
                    <AddOutline color="white" size={20} />
                {/if}
            </Button>
        </Row>
    </Column>
{/key}
